export const FormConstants = {
  MaxLengths: {
    AnswerSetComment: 25000,
  },
};
